import React from "react";

import { Trans } from "react-i18next";
import { Navigate } from "react-router-dom";

import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

import { useWifiQrCode } from "../../lib/hooks/useQueryBoard";

import Title from "../../components/Title";
import Curve from "../../components/Animations/PageTransitions/Curve";
import BackButton from "../../components/BackButton";

const WifiImg = styled("img")({
  width: "80%",
  maxWidth: "75rem",

  "@media screen and (orientation: landscape)": {
    width: "20%",
  },
});

const Wifi = React.memo(() => {
  const wifiQrCode = useWifiQrCode();

  if (!wifiQrCode) {
    return Navigate({ to: "/" });
  }

  return (
    <Curve>
      <div className="d-flex align-items-center flex-column h-100">
        <BackButton to="/" />
        <Title>
          <Typography variant="h1">
            <Trans i18nKey="wifi:title" />
          </Typography>
        </Title>
        <WifiImg alt="Wi-Fi QR code" src={wifiQrCode} />
      </div>
    </Curve>
  );
});

export default Wifi;
